{ "expectedResult": "Ожидаемый результат", "result": "Результат", "testData": "Тестовые данные" }
